<template>
  <v-form
    ref="form"
    :disabled="disabled"
  >
    <!-- Top edit button -->
    <avs-editInfoButton
      v-if="isEditable"
      :isEnabled="!disabled"
      @click="$event => setEditable(disabled)"
    />

    <v-card-title>{{ document.title }} </v-card-title>
    <v-card-subtitle v-html="document.description"></v-card-subtitle>

    <v-card-text
      v-for="(section, index) in document.sections"
      :key="index"
    >
      <h4>{{ section.title }}</h4>
      <span>{{ section.description }}</span>

      <component
        v-for="(field, idx) in section.fields"
        :key="idx"
        :is="field.type.component.name"
        v-bind="field.type.options"
        :label="field.name"
        :typename="field.type.name"
        :values="field.values"
        :formDisabled="disabled"
        @input="v => handleFieldUpdate(field, v)"
        @disableButton="
          $event => {
            btnDisabled = $event
          }
        "
      />
      <v-divider class="mt-6"></v-divider>
    </v-card-text>

    <div v-if="isEditable && !disabled">
      <v-col class="d-flex justify-end gap-4">
        <avs-saveButton @click="handleSave" />
        <avs-cancelButton @click="handleCancel" />
      </v-col>
    </div>
  </v-form>
</template>

<script>
import { DocumentService } from "@/services/documents"
import { isEqual } from "@/utils/object"
import { injectValues } from "@/utils/datamodels"
import Checkbox from "@/components/ri3/documents/fieldtypes/Checkbox.vue"
import DateField from "@/components/ri3/documents/fieldtypes/DateField.vue"
import ImageField from "@/components/ri3/documents/fieldtypes/ImageField.vue"
import Selector from "@/components/ri3/documents/fieldtypes/Selector.vue"
import Table from "@/components/ri3/documents/fieldtypes/Table.vue"
import TextField from "@/components/ri3/documents/fieldtypes/TextField.vue"
import TextArea from "@/components/ri3/documents/fieldtypes/TextArea.vue"
import Break from "@/components/ri3/documents/fieldtypes/Break.vue"

export default {
  name: "DocumentValuesForm",
  components: { Checkbox, DateField, ImageField, Selector, Table, TextField, TextArea, Break },
  props: {
    documentId: {
      type: Number,
      required: true
    },
    isEditable: {
      type: Boolean,
      default: true
    },
    template: {
      type: Object,
      required: true
    },
    values: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      btnDisabled: false,
      disabled: true,
      document: {}
    }
  },
  methods: {
    handleFieldUpdate(item, newval) {
      item.values = newval
      // FUck'in force update either fields :value does not updates
      // correctly, don't understand why...
      this.$forceUpdate()
    },
    extractValues(document) {
      let result = []
      for (const section of document.sections) {
        for (const field of section.fields) {
          if (field.values) {
            result.push({
              field: field.id,
              values: field.values
            })
          }
        }
      }
      return result
    },
    setEditable(val = true) {
      this.disabled = !val
    },
    handleCancel() {
      this.setEditable(false)
      this.document = injectValues(this.template, this.values)
      this.$emit("cancel")
    },
    handleSave() {
      if (this.$refs.form.validate()) {
        if (isEqual(this.template, this.value)) {
          // Objects are equal, no changes to perform
          this.$emit("success", false)
          this.setEditable(false)
        } else {
          // Save documents values (edit)
          const values = this.extractValues(this.document)
          DocumentService.values
            .put(this.documentId, values)
            .then(response => {
              this.$emit("input", response)
              this.$emit("success", true)
              this.setEditable(false)
            })
            .catch(error => {
              this.$emit("error", error)
            })
        }
      }
    }
  },
  watch: {
    values: {
      immediate: true,
      handler(newValues, oldValues) {
        if (newValues) {
          this.document = injectValues(this.template, newValues)
        }
      }
    }
  }
}
</script>
